import React, { useState, useRef } from 'react';
import Dropdown from 'react-dropdown';
import { isAndroid, isMobile } from 'react-device-detect';
import Checkbox from 'material-ui/Checkbox';
import Snackbar from 'material-ui/Snackbar';
import { processVideoFile, VIDEO_ERROR_MESSAGES } from './VideoPicker';

const CHECKED_YES = 1;
const CHECKED_NO = 0;
const EnvBug = [
  { value: 0, label: '選択してください' },
  { value: 1, label: 'iOSアプリ版' },
  { value: 2, label: 'Andoridアプリ版' },
  { value: 3, label: 'PC版（ブラウザ：Google Chrome)' },
  { value: 4, label: 'PC版（ブラウザ：safari)' },
  { value: 5, label: 'PC版（ブラウザ：その他)' },
  { value: 6, label: 'スマホブラウザ版（iOS)' },
  { value: 7, label: 'スマホブラウザ版（Android)' },
];
const OtherEnvBug = [
  { value: 0, label: '選択してください' },
  { value: 1, label: 'iOSアプリ版' },
  { value: 2, label: 'Andoridアプリ版' },
  { value: 3, label: 'PC版' },
  { value: 4, label: 'スマホブラウザ版' },
];

const defaultOption1 = EnvBug[0];
const defaultOption2 = OtherEnvBug[0];

function FormBug(props) {
  const [image, setImage] = useState({
    error: false,
    message: '',
    image: null,
  });

  const [data, setData] = useState({
    envBug: { value: 0, label: defaultOption1.label },
    otherEnvBug: { value: 0, label: defaultOption2.label },
    content: '',
    file: null,
    videoFile: null,
    videoDuration: null,
    videoMd5: null,
    checked: CHECKED_YES,
  });

  const [err, setErr] = useState({
    envBug: false,
    content: false,
  });

  // State xử lý video
  const [videoProcessing, setVideoProcessing] = useState(false);
  const [videoError, setVideoError] = useState('');
  const [videoPreviewUrl, setVideoPreviewUrl] = useState(null);
  const [videoProgress, setVideoProgress] = useState(0);
  // Ref để cancel callback cũ khi chọn file mới
  const processIdRef = useRef(0);

  const onChange = (name, value) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const getImageData = (file) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (ev) => {
      setImage({
        error: false,
        message: '',
        image: ev.target.result,
      });
    };
  };

  const selectFile = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const fileType = file.type;

    // Nhánh 1: ảnh hợp lệ — cancel video nếu đang progress + thay thế
    if (
      fileType === 'image/png' ||
      fileType === 'image/jpeg' ||
      fileType === 'image/jpg' ||
      fileType === 'image/gif'
    ) {
      // Cancel video processing nếu đang chạy
      processIdRef.current++;
      setVideoProcessing(false);
      setVideoProgress(0);
      setVideoError('');
      setVideoPreviewUrl(null);

      getImageData(file);
      setData({
        ...data,
        file,
        videoFile: null,
        videoDuration: null,
        videoMd5: null,
      });
      return;
    }

    // Nhánh 2: video hợp lệ (MP4 hoặc MOV)
    if (fileType === 'video/mp4' || fileType === 'video/quicktime') {
      // Reset progress + tăng processId để ignore callback cũ
      const currentProcessId = ++processIdRef.current;
      setVideoProcessing(true);
      setVideoError('');
      setVideoProgress(0);
      setImage({ error: false, message: '', image: null });
      processVideoFile(file, {
        onProgress: (pct) => {
          // Chỉ update nếu vẫn là process hiện tại (tránh nhấp nháy)
          if (processIdRef.current === currentProcessId) {
            setVideoProgress(pct);
          }
        },
        onError: (code) => {
          if (processIdRef.current !== currentProcessId) return;
          setVideoError(VIDEO_ERROR_MESSAGES[code]);
          setVideoProcessing(false);
          // Chỉ xóa file khỏi state nếu CHƯA có file hợp lệ trước đó
          if (!data.videoFile && !data.file) {
            setVideoPreviewUrl(null);
          }
        },
        onSuccess: ({ compressedBlob, duration, md5Sum }) => {
          if (processIdRef.current !== currentProcessId) return;
          const thumbUrl = URL.createObjectURL(compressedBlob);
          setVideoPreviewUrl(thumbUrl);
          setData({
            ...data,
            file: null,
            videoFile: compressedBlob,
            videoDuration: duration,
            videoMd5: md5Sum,
          });
          setVideoProcessing(false);
        },
      });
      return;
    }

    // Nhánh 3: video sai format (avi, mkv, ...) → chỉ show lỗi, KHÔNG xóa file cũ
    if (fileType.startsWith('video/')) {
      setVideoError(VIDEO_ERROR_MESSAGES['invalid_format']);
      setVideoProcessing(false);
    } else {
      // Các loại file khác → lỗi format ảnh (chỉ show snackbar)
      setImage({ error: true });
    }
  };

  const onAccept = () => {
    const envBugError = data.envBug.value === 0;
    const contentError = data.content.replace(/\s/g, '').length === 0;

    setErr({ envBug: envBugError, content: contentError });

    if (!contentError && !envBugError) {
      props.onChangeStepCategory(1, {
        ...data,
        image: image.image,
      });
    }
  };

  return (
    <div>
      <p className="titleTextField">症状が発生したご利用の環境</p>
      <Dropdown
        className="dropdown-contact"
        options={EnvBug}
        onChange={(e) => onChange('envBug', e)}
        value={defaultOption1}
        placeholder="Select an option"
      />
      {err.envBug && (
        <p className="errMsgContact">環境を選択してください</p>
      )}

      <p className="titleTextField">他で兼用している環境があればお答えください（任意）</p>
      <Dropdown
        className="dropdown-contact"
        options={OtherEnvBug}
        onChange={(e) => onChange('otherEnvBug', e)}
        value={defaultOption2}
        placeholder="Select an option"
      />

      <p className="titleTextField">不具合の詳細（症状・日時・お客様のお名前など具体的にお書きください）</p>
      <textarea
        className="inputCus inputContact"
        onChange={(e) => onChange('content', e.target.value)}
        placeholder="例：3月9日に山田ステラ様からチャット相談の申し込みがあり、「チャット開始」ボタンを押すと、画面が真っ白になる"
        value={data.content}
      />
      {err.content && (
        <p className="errMsgContact">お問い合わせ内容を入力してください</p>
      )}

      <p className="titleTextField" style={{ marginBottom: 0, marginTop: 30 }}>
        不具合時のスクリーンショット / 動画（任意）
      </p>
      <div className="fileContact">
        <div className="btn-wrap btnFile">
          <label className="btn-raised color_white">
            <p className="btn-raised__text">ファイルを選択</p>
            <input
              type="file"
              className="btn-raised__file inputChooseFile"
              accept="image/png,image/jpeg,image/jpg,image/gif,video/mp4,video/quicktime"
              onChange={(e) => selectFile(e)}
            />
          </label>
        </div>

        {/* Preview ảnh */}
        {isMobile ? (
          <>
            {image.image && (
              <img src={image.image} className="imageContact" alt="preview" />
            )}
            <p className="txtFileContact">
              {image.image ? '写真1枚' : data.videoFile ? '動画1本' : 'ファイル未選択'}
            </p>
          </>
        ) : (
          <>
            <p className="txtFileContact">
              {image.image ? '写真1枚' : data.videoFile ? '動画1本' : 'ファイル未選択'}
            </p>
            {image.image && (
              <img src={image.image} className="imageContact" alt="preview" />
            )}
          </>
        )}

        {/* Progress nén video */}
        {videoProcessing && (
          <div className="txtFileContact" style={{ marginTop: 18 }}>
            <p>動画を処理中... {videoProgress}%</p>
            <div style={{ width: 100, height: 6, background: '#e0e0e0', borderRadius: 3, overflow: 'hidden' }}>
              <div style={{ width: `${videoProgress}%`, height: '100%', background: '#11ad9d', transition: 'width 0.3s' }} />
            </div>
          </div>
        )}

        {/* Preview video thumbnail */}
        {videoPreviewUrl && !videoProcessing && (
          <div style={{ position: 'relative', display: 'inline-block', marginTop: 8,  marginLeft: 32 }}>
            <video
              src={videoPreviewUrl}
              style={{ width: 100, height: 'auto', display: 'block' }}
            />
            <span style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: 32,
              color: 'white',
              textShadow: '0 0 4px #000',
              pointerEvents: 'none',
            }}>
              ▶
            </span>
          </div>
        )}

        {/* Error video — bỏ inline text, dùng Snackbar bên dưới */}
      </div>

      <p className="text-message-contact">
        ※症状がわかる画面のスクリーンショットや動画をいただくと調査がスムーズに行えますので、撮影が可能な場合はご協力いただけると幸いです。
      </p>

      <p className="titleTextField">返信の有無</p>
      <div
        className={
          isAndroid
            ? 'checkBoxContact checkBoxContactAndroid'
            : 'checkBoxContact checkBoxContactIOS'
        }
      >
        <Checkbox
          label="必要"
          onCheck={() => onChange('checked', CHECKED_YES)}
          checked={data.checked === CHECKED_YES}
          style={{ color: '#c7bfbf' }}
          labelStyle={{ fontWeight: 'normal' }}
        />
        <Checkbox
          label="不要"
          onCheck={() => onChange('checked', CHECKED_NO)}
          checked={data.checked === CHECKED_NO}
          style={{ color: '#c7bfbf' }}
          labelStyle={{ fontWeight: 'normal' }}
        />
      </div>
      <button onClick={onAccept} className="submitContact" disabled={videoProcessing}>
        内容確認
      </button>

      {/* Snackbar lỗi format ảnh — giữ nguyên */}
      <Snackbar
        open={image.error}
        message={'ファイル形式が不正です。画像（PNG/JPG/GIF）または動画（MP4/MOV）を選択してください。'}
        autoHideDuration={2500}
        onRequestClose={() => setImage({ ...image, error: false })}
      />
      {/* STEL-1440: Snackbar lỗi video */}
      <Snackbar
        open={!!videoError}
        message={videoError}
        autoHideDuration={3000}
        onRequestClose={() => setVideoError('')}
      />
    </div>
  );
}

export default FormBug;
